import {
  ChatStateType,
  ChatProviderType,
  HealthCheckRunStatus,
  ScheduleType,
} from "./api/api_types";
import { Icon, IconBrandTelegram } from "@tabler/icons-react";
import { MantineColor } from "@mantine/core";

export const ChatStateNameAndEmoji: Record<ChatStateType, string> = {
  ACTIVE: "🟢 Notifications ON",
  INACTIVE: "🔴 Notifications OFF",
  SETUP: "📲 Setup",
};

export const ChatStateEmoji: Record<ChatStateType, string> = {
  ACTIVE: "🟢",
  INACTIVE: "🔴",
  SETUP: "📲",
};

export const ChatProviderIcon: Record<ChatProviderType, Icon> = {
  TELEGRAM: IconBrandTelegram,
};

export const ChatProviderColor: Record<ChatProviderType, string> = {
  TELEGRAM: "	#24A1DE",
};

export const HealthCheckRunStatusColors: Record<
  HealthCheckRunStatus,
  MantineColor
> = {
  IN_PROGRESS: "blue",
  PASS: "green",
  FAIL: "red",
  TIMEOUT: "yellow",
};

export const ScheduleTypeDisplay: Record<string, string> = {
  [ScheduleType.ONCE]: "Once",
  [ScheduleType.MINUTES]: "Minutes",
  [ScheduleType.HOURLY]: "Hourly",
  [ScheduleType.DAILY]: "Daily",
  [ScheduleType.WEEKLY]: "Weekly",
  [ScheduleType.BIWEEKLY]: "Biweekly",
  [ScheduleType.MONTHLY]: "Monthly",
  [ScheduleType.BIMONTHLY]: "Bimonthly",
  [ScheduleType.QUARTERLY]: "Quarterly",
  [ScheduleType.YEARLY]: "Yearly",
  [ScheduleType.CRON]: "Cron",
};
